import React from "react";
import { connect } from 'react-redux';
import Notification from './Notification';

const Notifications = ({ notifications }) => {

  if (notifications && notifications.length < 1) {
    return <React.Fragment></React.Fragment>
  }

  return (
    <div className="fixed inset-0 pointer-events-none" style={{ zIndex: 1500 }}>
      {notifications && notifications.map(notification =>
        <Notification key={notification.id} notification={notification} />
      )}
    </div>
  )
}


const mapStateToProps = (state) => {
  return {
    notifications: state.notifications,
  }
}

const mapDispatchToProps = dispatch => ({
  // addNotification: (notification,removeAfter) => dispatch(ACTIONS.addNotification(notification,removeAfter)),
  // closeNotification: (id) => dispatch(ACTIONS.closeNotification(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Notifications)